import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {LabelFn, LabelSettings} from "@progress/kendo-angular-progressbar";
import {GroupDescriptor, process} from "@progress/kendo-data-query";
import {ImportadorIfoodService} from "../../services/importador-ifood.service";
import {ProdutoService} from "../../services/produto.service";

@Component({
  selector: 'app-painel-importacao-produtos',
  templateUrl: './painel-importacao-produtos.component.html',
  styleUrls: ['./painel-importacao-produtos.component.scss']
})
export class PainelImportacaoProdutosComponent implements OnInit {

  /** Alinhado a server/lib/emun/EnumDisponibilidadeProduto */
  private static readonly DISP_SEMPRE = 0;
  private static readonly DISP_DIA_SEMANA = 1;
  private readonly diasSemanaAbrev = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  @Input() modoExibicao = false;
  @Input() bloquearSincronizacao = false;
  @Output() onImportou = new EventEmitter();
  importacao: any = {total: 0, totalImportar: 0, totalAtualizar: 0, sincronizando: false, totalProcessados: 0, finalizou: false};
  produtosSincronizarPorCategoria: any  = []
  labelSincronizados: LabelSettings;
  labelCategoria: LabelSettings;
  naoImportados = []
  naoAtualizados = []
  emptyStyles: {[key: string]: any} = {  background: '' };
  progressStyles: {[key: string]: any} = {}
  categorias = [];
  finalizouSincronizacao: boolean;
  importou: boolean
  buscando = true;
  modoRede = false;
  catalogo: any = {}
  constructor( private importador:  ImportadorIfoodService,
               private produtoService: ProdutoService) { }

  ngOnInit(): void {
    this.labelSincronizados  = {
      format: this.formatterGlobal,
      position: 'center',
    };


  }

  setModoRede(catalogo){
    this.catalogo = catalogo;
    this.modoRede = true;
  }

  obtenhaLabel(categoriaImportando: any): LabelSettings{
    return {
      format: (value) => {
        if(!categoriaImportando) return '0/0'

        return `${value}/${categoriaImportando.total}`;
      },
      position: 'center',
    }
  }

  public formatterGlobal: LabelFn = (value: number): string => {
    return `${value}/${this.importacao.total}`;
  }

  setProdutosSincronizar(produtosNovos, produtosAtualizar, produtosRemovidos, categorias){
    this.categorias = categorias;
    this.produtosSincronizarPorCategoria = [];
    this.importacao  = {
      total: 0,
      totalImportar: 0,
      totalAtualizar: 0,
      totalProcessados: 0,
      totalSincronizados: 0,
      importando: false,
      finalizou: false
    }
    this.progressStyles = {
      color: '#fff',
      background: '#1050bb'
    };
    this.naoImportados = [];
    this.naoAtualizados = [];
    this.importacao.totalImportar = produtosNovos.length;
    this.importacao.totalAtualizar = produtosAtualizar.length;
    this.importacao.totalRemover = produtosRemovidos.length;
    this.importacao.total =     this.importacao.totalImportar +     this.importacao.totalAtualizar;

    for(let i = 0 ; i  < this.categorias.length ; i++) {
      let categoria: any = this.categorias[i];
      let categoriaKey = categoria.id ? categoria.id : (categoria.codigoIfood || categoria.codigoPdv || categoria.nome);

      let produtosNovosCategoria = produtosNovos.filter((produto: any) => produto.categoria.id ? produto.categoria.id === categoriaKey :
        (produto.categoria.codigoIfood || produto.categoria.codigoPdv || produto.categoria.nome) === categoriaKey);

      let produtosRemovidosCategoria =
        produtosRemovidos.filter( (produto: any) =>  produto.categoria.id ? produto.categoria.id === categoriaKey :
        (produto.categoria.codigoIfood || produto.categoria.codigoPdv || produto.categoria.nome) === categoriaKey)

      let produtosAtualizarCategoria = produtosAtualizar.filter((produto: any) => produto.categoria.id ?
        produto.categoria.id === categoriaKey :
        (produto.categoria.codigoIfood || produto.categoria.codigoPdv || produto.categoria.nome) === categoriaKey);

      if( produtosNovosCategoria.length || produtosAtualizarCategoria.length || produtosRemovidosCategoria.length){

        let categoriaSincronizar =  {
          categoriaKey: categoriaKey,
          produtos: [],
          importouTodos: false,
          finalizou: false,
          nomeCategoria: categoria.nome,
          totalImportar: produtosNovosCategoria.length,
          totalAtualizar: produtosAtualizarCategoria.length,
          totalRemover: produtosRemovidosCategoria.length,
          total: produtosNovosCategoria.length + produtosAtualizarCategoria.length + produtosRemovidosCategoria.length,
          totalProcessados: 0,
          totalSincronizados: 0,
          progressStyles: {   color: '#fff',
            background: '#1050bb'
          },
          exibirProdutos: this.importacao.totalImportar < 200
        }

        for(let j = 0;  j < produtosNovosCategoria.length; j++){
          let novoProduto = produtosNovosCategoria[ j];

          novoProduto.importar = true;

          categoriaSincronizar.produtos.push(novoProduto)
        }

        for(let j = 0;  j < produtosAtualizarCategoria.length; j++){
          let produto = produtosAtualizarCategoria[ j];

          produto.sincronizar = true;

          produto.qtdeAdicionaisNovos =  produto.camposAdicionais.filter( adicional => !adicional.id).length;
          produto.qtdeAdicionaisAtualizar =  produto.camposAdicionais.filter( adicional => adicional.id != null).length;

          categoriaSincronizar.produtos.push(produto)
        }
        for(let j = 0;  j < produtosRemovidosCategoria.length; j++){
          let produto = produtosRemovidosCategoria[ j];

          produto.remover = true;

          categoriaSincronizar.produtos.push(produto)
        }

        this.produtosSincronizarPorCategoria.push(categoriaSincronizar)

      }

    }

    this.buscando = false;

  }

  ehProdutoPizzaComTamanhos(produto: any): boolean {
    return produto && produto.tipo === 'pizza' &&  produto.tamanhos?.length > 0;
  }

  obtenhaQtdeTamanhos(produto: any): number {
    return produto.tamanhos?.length || 0;
  }

  obtenhaPrecoMinimoTamanhos(produto: any): number | null {
    if(!this.ehProdutoPizzaComTamanhos(produto)) return null;
    let minimo: number | null = null;
    for(const t of produto.tamanhos){
      const valor = this.obtenhaPrecoExibicaoTamanho(t);
      if(valor == null) continue;
      if(minimo === null || valor < minimo) minimo = valor;
    }
    return minimo;
  }

  private obtenhaPrecoExibicaoTamanho(tamanho: any): number | null {
    if(!tamanho) return null;
    if(tamanho.novoPreco != null && tamanho.novoPreco !== '' && Number(tamanho.novoPreco) >= 0)
      return Number(tamanho.novoPreco);
    if(tamanho.preco != null && tamanho.preco !== '') return Number(tamanho.preco);
    return null;
  }

  obtenhaDescricaoTamanhoImportacao(tamanho: any): string {
    if(!tamanho) return '';
    return tamanho.descricao || (tamanho.template && tamanho.template.descricao) || '';
  }


  ehAtualizarDispSempreDisponivel(produto: any): boolean {
    return !!(produto && produto.sincronizar && produto.atualizarDisponibilidade &&
      Number(produto.disponibilidade) === PainelImportacaoProdutosComponent.DISP_SEMPRE);
  }

  ehAtualizarDispDiaDaSemana(produto: any): boolean {
    return !!(produto && produto.sincronizar && produto.atualizarDisponibilidade &&
      Number(produto.disponibilidade) === PainelImportacaoProdutosComponent.DISP_DIA_SEMANA);
  }

  /** Resumo dos dias (ex.: Seg, Qua, Sex) a partir de disponibilidades[].periodos[].dias */
  obtenhaResumoDiasDisponibilidadeImportacao(produto: any): string {
    const diasSet = new Set<number>();
    const lista = produto && produto.disponibilidades;
    if(Array.isArray(lista)){
      for(const disp of lista){
        const periodos = disp && disp.periodos ? disp.periodos : [];
        for(const periodo of periodos){
          const diasArr = periodo && periodo.dias ? periodo.dias : [];
          for(const d of diasArr){
            const dia = d != null && typeof d === 'object' ? d.dia : d;
            if(dia != null && !isNaN(Number(dia))){
              const n = Number(dia);
              if(n >= 0 && n <= 6) diasSet.add(n);
            }
          }
        }
      }
    }
    if(!diasSet.size)
      return 'Dias da semana';
    const ordenados = Array.from(diasSet).sort((a, b) => a - b);
    return ordenados.map(d => this.diasSemanaAbrev[d] || String(d)).join(', ');
  }

  async importeCategoria(categoriaSincronizar: any){
    if(this.bloquearSincronizacao || categoriaSincronizar.sincronizando ) return;

    console.log('categoria sincronizar' + categoriaSincronizar.nomeCategoria)

    categoriaSincronizar.sincronizando = true;

    for(let j = 0; j <  categoriaSincronizar.produtos.length ; j++){
      let produto: any = categoriaSincronizar.produtos[j];

      if(produto.importar ) {
        await this.importeProduto(produto);
      } else if(produto.remover ){
        await this.removaProdutoCatalogo(produto);

      } else {
        await this.atualizeProduto(produto);
      }

      this.importacao.totalProcessados++;
      categoriaSincronizar.totalProcessados++;

      if(!produto.erro){
        categoriaSincronizar.totalSincronizados++;
        this.importacao.totalSincronizados++;
      }

    }

    categoriaSincronizar.importouTodos  =  categoriaSincronizar.totalSincronizados ===  categoriaSincronizar.total;

    if(categoriaSincronizar.importouTodos){
      categoriaSincronizar.progressStyles.background = '#8EBC00';
    }  else {
      categoriaSincronizar.progressStyles.background = '#f1556c';
    }
    await this.sleep(1000);
    categoriaSincronizar.sincronizando = false;
    categoriaSincronizar.finalizou = true;
  }

  async sincronizeTodos(){
    if(this.bloquearSincronizacao || this.importacao.sincronizando ) return;
    this.naoImportados = [];
    this.naoAtualizados = [];
    this.finalizouSincronizacao = false;
    this.importacao.sincronizando = true;

    for(let i = 0; i <  this.produtosSincronizarPorCategoria.length ; i++){
      let categoriaSincronizar: any = this.produtosSincronizarPorCategoria[i];

      await this.importeCategoria(categoriaSincronizar)

    }

    this.importacao.importouTodos =  this.importacao.totalSincronizados === this.importacao.total;

    if(  this.importacao.importouTodos){
      this.progressStyles.background = '#8EBC00';
      this.importador.finalizouImportacao().then( () => {})
    } else {
      this.progressStyles.background = '#f1556c';
    }

    this.importacao.sincronizando = false;
    this.importacao.finalizou = true;
  }

  async importeProduto(produto: any) {
    console.log('importar: ' + produto.nome)
    delete produto.erro;

    if(this.bloquearSincronizacao || produto.id || produto.sincronizando) return;

    produto.sincronizando = true;

    let produtoSalvo = await this.importador.importeProduto(produto).catch( (erro) => {
      produto.erro = erro;
      console.error(`erro importar produto ${produto.nome}`, erro)
      this.naoImportados.push(produto)
    })

    if(produtoSalvo && produtoSalvo.id){
      Object.assign( produto, produtoSalvo)
      produto.importou = true;
      this.importou = true; //so marca que houve importação
      this.onImportou.emit(produto)
    }

    produto.sincronizando = false;

  }
  async removaProdutoCatalogo(produto: any){
    if(this.bloquearSincronizacao) return;
    produto.sincronizando = true;
    delete   produto.erro;

    await this.produtoService.removaProdutoCatalogo( [produto]).catch( erro => {
      produto.erro = erro;
    })

    produto.sincronizando = false;

    if(!produto.erro){
      produto.sincronizado = true;
    }
  }
  async atualizeProduto(produto: any) {
    if(this.bloquearSincronizacao) return;
    produto.sincronizando = true;
    delete   produto.erro;

    if(this.modoRede){
      await this.produtoService.sincronizeProdutoDaRede(this.catalogo, produto).catch( erro => {
        produto.erro = erro;
      })
    } else {
      await this.produtoService.sincronizeProduto( [produto]).catch( erro => {
        produto.erro = erro;
      })
    }

    produto.sincronizando = false;

    if(!produto.erro){
      produto.sincronizado = true;
      this.onImportou.emit(produto)
    }

  }


  obtenhaAdicionais(produto: any = {}) {
    let opcoes = [];
    let groups: GroupDescriptor[] =  [{ field: 'nomeAdicional' }];

    if(produto.camposAdicionais && produto.camposAdicionais.length){
      produto.camposAdicionais.forEach( (adicionalProduto: any) => { // Novo produto ou novos adicionais
        if(adicionalProduto.opcoesDisponiveis && adicionalProduto.opcoesDisponiveis.length){
          adicionalProduto.opcoesDisponiveis.forEach((opcaoAdicional) => {
            let novaOpcao: any = Object.assign({}, opcaoAdicional)
            novaOpcao.nomeAdicional = adicionalProduto.nome;
            novaOpcao.idAdicional = adicionalProduto.id;
            if(adicionalProduto.codigoIfood)
              novaOpcao.nomeAdicional = String(`${ novaOpcao.nomeAdicional} (${adicionalProduto.codigoIfood})`)

            opcoes.push(novaOpcao)
          })
        }
      })
    }

    if(produto.camposAdicionaisRemovidos && produto.camposAdicionaisRemovidos.length){
      produto.camposAdicionaisRemovidos.forEach( (adicionalProduto: any) => { // Novo produto ou novos adicionais
        if(adicionalProduto.opcoesDisponiveis && adicionalProduto.opcoesDisponiveis.length){
          adicionalProduto.opcoesDisponiveis.forEach((opcaoAdicional) => {
            let novaOpcao: any = Object.assign({}, opcaoAdicional)
            novaOpcao.removida = true;
            novaOpcao.nomeAdicional = adicionalProduto.nome;

            if(adicionalProduto.codigoIfood)
              novaOpcao.nomeAdicional = String(`${ novaOpcao.nomeAdicional} (${adicionalProduto.codigoIfood})`)

            novaOpcao.idAdicional = adicionalProduto.id;
            opcoes.push(novaOpcao)
          })
        }
      })
    }

    if(produto.opcoesAtualizadas && produto.opcoesAtualizadas.length){ // DTOProdtuSincronizar
      produto.opcoesAtualizadas.forEach( (novaOpcao) => {
        opcoes.push(novaOpcao)
      })
    }

    if(produto.opcoesRemovidas && produto.opcoesRemovidas.length){ // DTOProdtuSincronizar
      produto.opcoesRemovidas.forEach( (novaOpcao) => {
        novaOpcao.removida = true;
        opcoes.push(novaOpcao)
      })
    }

    const temTamanhos = !!(produto.tamanhos && produto.tamanhos.length > 0);
    produto.naoTemOpcoesAdicionais = !opcoes.length;
    produto.naoTemConteudoDetalhe = !opcoes.length && !temTamanhos;

    return process(opcoes, { group: groups });
  }

  reimporteProdutos() {
    this.setProdutosSincronizar(this.naoImportados, this.naoAtualizados, [], this.categorias)

    this.sincronizeTodos();
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  toogleExibirProdutos(categoriaSincronizar: any) {
    categoriaSincronizar.exibirProdutos = !categoriaSincronizar.exibirProdutos;
  }
}
